import store from 'store';

/**
 * sessionStorage & localStorage are not available on iframes in incognito sessions.
 * Attempting to use the storage apis will throw an error.
 * @see https://stackoverflow.com/a/16427747
 */
const testStorage = '__janeStorageTest';

/** @todo access localStorage directly without `store`'s fallbacks */
export class Storage {
  static set<T>(key: string, data: T) {
    store.set(key, data);
  }

  static get<T>(key: string): T | undefined {
    return store.get(key);
  }

  static remove(key: string) {
    store.remove(key);
  }

  static clear() {
    store.clearAll();
  }

  static isAvailable() {
    try {
      localStorage.setItem(testStorage, testStorage);
      localStorage.removeItem(testStorage);
      return true;
    } catch {
      return false;
    }
  }
}

export class SessionStorage {
  static set(key: string, value: string) {
    sessionStorage.setItem(key, value);
  }

  static get(key: string) {
    return sessionStorage.getItem(key);
  }

  static remove(key: string) {
    sessionStorage.removeItem(key);
  }

  static clear() {
    sessionStorage.clear();
  }

  static isAvailable() {
    try {
      sessionStorage.setItem(testStorage, testStorage);
      sessionStorage.removeItem(testStorage);
      return true;
    } catch {
      return false;
    }
  }
}

export function isBrowserStorageAvailable() {
  return SessionStorage.isAvailable() && Storage.isAvailable();
}
